import { Segmented, Typography } from 'antd'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'

import { DashboardEmployeeFilter } from '@/Ship/Components/Dashboard/DashboardEmployeeFilter'
import { PERIOD_LABELS } from '@/Ship/Components/Dashboard/Overview/shared'
import { classNames } from '@/Ship/Helpers/classNames'
import { dashboardManager } from '@/Ship/Stores/DashboardManager'

import { OVERVIEW_PERIODS, type OverviewPeriod } from '@/Ship/Contracts/IHomeOverview'

import styles from './Overview/Overview.module.css'

const { Title } = Typography

/** Позначка, чиї цифри показує огляд. */
export const scopeLabel = (): string => {
    const { overview, isCompanyScope, employeeOptions, selectedUuid } = dashboardManager

    if (isCompanyScope) return 'Уся компанія'

    const name = overview?.scope.user?.fullName ?? employeeOptions.find((item) => item.uuid === selectedUuid)?.fullName

    return name ? `Показники: ${name}` : 'Мої показники'
}

/**
 * Шапка «Робочого столу»: назва, сьогоднішня дата, позначка «чиї цифри»
 * (уся компанія чи співробітник), праворуч — період рейтингів і фільтр по
 * співробітнику (лише з правом `dashboard_others`). Один ряд керування над
 * усіма блоками: фільтр у кожній картці означав би, що сусідні числа
 * пораховано за різні вікна.
 */
export const DashboardHeader = observer(({ title }: { title: string }) => {
    const today = dayjs().format('dddd, D MMMM YYYY')

    return (
        <header className={classNames(styles['header'])}>
            <div className={classNames(styles['headline'])}>
                <Title level={3} style={{ margin: 0 }}>
                    {title}
                </Title>
                <div className={classNames(styles['eyebrow'])}>
                    <span>{today.charAt(0).toUpperCase() + today.slice(1)}</span>
                    <span className={classNames(styles['scope'])} data-testid="dashboard-scope">
                        <span className={classNames(styles['scopeDot'])} />
                        {scopeLabel()}
                    </span>
                </div>
            </div>
            <div className={classNames(styles['controls'])}>
                <Segmented
                    aria-label="Період рейтингів"
                    data-testid="dashboard-period"
                    value={dashboardManager.period}
                    onChange={(value) => dashboardManager.setPeriod(value as OverviewPeriod)}
                    options={OVERVIEW_PERIODS.map((period) => ({ value: period, label: PERIOD_LABELS[period] }))}
                />
                <DashboardEmployeeFilter />
            </div>
        </header>
    )
})
